import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutYSplitStopsTableRecurringOrder extends Layout {
    sourceStopRecOrder: DataSource;
    tableRecOrderStops: Table;
}
